/**
 * Zod schemas for the Praxismodul feature (Prompt 17 §4). Shared between
 * backend route validation and frontend forms. Pure TS, no runtime deps
 * besides Zod.
 */
import { z } from 'zod';
import { DAY_OF_WEEK_BOUNDS, PRAXISMODUL_RETURN_GRACE_BOUNDS, SCHOOL_HOUR_BOUNDS, } from './constants.js';
const HHMM = /^([01]\d|2[0-3]):[0-5]\d$/;
const YYYY_MM_DD = /^\d{4}-\d{2}-\d{2}$/;
export const SchoolHourUpdateSchema = z
    .object({
    startTime: z.string().regex(HHMM, 'Ungültiges Zeitformat (HH:MM)'),
    endTime: z.string().regex(HHMM, 'Ungültiges Zeitformat (HH:MM)'),
})
    .refine((d) => d.startTime < d.endTime, {
    message: 'startTime muss vor endTime liegen',
    path: ['endTime'],
});
export const PraxismodulEntryCreateSchema = z
    .object({
    studentId: z.number().int().positive(),
    dayOfWeek: z.number().int().min(DAY_OF_WEEK_BOUNDS.MIN).max(DAY_OF_WEEK_BOUNDS.MAX),
    hourStart: z.number().int().min(SCHOOL_HOUR_BOUNDS.MIN).max(SCHOOL_HOUR_BOUNDS.MAX),
    hourEnd: z.number().int().min(SCHOOL_HOUR_BOUNDS.MIN).max(SCHOOL_HOUR_BOUNDS.MAX),
    validFrom: z.string().regex(YYYY_MM_DD, 'Datum muss im Format YYYY-MM-DD vorliegen.'),
    validUntil: z.string().regex(YYYY_MM_DD, 'Datum muss im Format YYYY-MM-DD vorliegen.'),
})
    .refine((d) => d.hourStart <= d.hourEnd, {
    message: 'hourStart muss <= hourEnd sein',
    path: ['hourEnd'],
})
    .refine((d) => d.validFrom <= d.validUntil, {
    message: 'validFrom muss <= validUntil sein',
    path: ['validUntil'],
});
export const PRAXISMODUL_RETURN_GRACE_BOUND_VALUES = PRAXISMODUL_RETURN_GRACE_BOUNDS;
//# sourceMappingURL=praxismodul.js.map